import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { hasRole, isAdminNotConsultant } from "@/js/http/auth.js";
import DenominationComponent from "@/components/appellation/DenominationComponent.vue";
export default {
  name: "DenominationPopin",
  props: {
    loggedUserData: Object,
    regionIdSelected: {
      default: null,
      type: Number
    },
    parentAppellationIdSelected: {
      default: null,
      type: Number
    }
  },
  data: function data(_this) {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      isEdit: false,
      denomination: {
        id_appellation: null,
        region: {
          id: null
        },
        id_parent_appellation: null,
        appellation: ""
      }
    };
  },
  computed: {
    canManageAppellations: function canManageAppellations() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_APPELLATION);
    },
    isAuthorized: function isAuthorized() {
      return isAdminNotConsultant(this.loggedUserData) && this.canManageAppellations;
    }
  },
  components: {
    DenominationComponent: DenominationComponent
  },
  created: function created() {
    if (!this.isAuthorized) {
      this.cancel();
      return;
    }
    if (this.regionIdSelected) this.denomination.region.id = this.regionIdSelected;
    if (this.parentAppellationIdSelected) this.denomination.id_parent_appellation = this.parentAppellationIdSelected;
  },
  methods: {
    open: function open() {
      var _this2 = this;
      this.dialog = true;
      return new Promise(function (resolve, reject) {
        _this2.resolve = resolve;
        _this2.reject = reject;
      });
    },
    openEdit: function openEdit(item) {
      var _this3 = this;
      this.dialog = true;
      this.isEdit = true;
      this.appellation = _objectSpread({}, item);
      return new Promise(function (resolve, reject) {
        _this3.resolve = resolve;
        _this3.reject = reject;
      });
    },
    agree: function agree(data) {
      this.resolve(true);
      this.dialog = false;
      this.$emit("closed", {
        confirmed: true,
        data: data
      });
    },
    cancel: function cancel() {
      this.resolve(false);
      this.dialog = false;
      this.$emit("closed", false);
    }
  }
};